const state= {
    loading: false,
    Items:{
        items:[],
        total:0,
    }
};

const getters = {
    Items : (state) => state.Items,
    Loading : (state) => state.loading,
};


const actions = {
    async getItems({commit}, params){
        commit( 'setLoading', true );
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/work-finding`, {params:params})
                .then(response => {
                    commit( 'setLoading', false );
                    commit( 'setItems', response.data.data );
                    resolve( response.data.data );
                })
                .catch(error => {
                    commit( 'setLoading', false );
                    reject( error )
                });
        });
    },
    async saveItem({commit}, params){
        let formData = new FormData();
        formData.append('job_id', params.data.job_id);
        formData.append('description', params.data.description || '');
        formData.append('raise_issue', params.data.raise_issue);
        formData.append('sla_id', params.data.sla_id || '');
        if(params.photos.length) {
            for(let i = 0; i < params.photos.length; i++){
                formData.append(`photos[${i}]`, params.photos[i]);
            }
        }

        let api = 'api/work-finding';
        if(params.data.id)
            api += `/${params.data.id}`;

        return new Promise (( resolve, reject ) => {
            global.axios(api, {
                method: 'POST',
                data: formData,
                headers: {
                    Accept: "application/json",
                },
            })
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async deleteItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`api/work-finding`, {
                data: params
            })
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
};

const mutations = {
    setItems (state, data) {
        state.Items = data;
    },
    setLoading (state, data) {
        state.loading = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
